import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLang } from "@/context/LanguageContext";

export function FalseDeclarationWarning({ open, onCancel, onContinue, found = false }) {
  const { t } = useLang();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="sm:max-w-md text-center" data-testid="false-declaration-warning">
        <DialogHeader><DialogTitle icon={AlertTriangle} className="font-display">{t("fd.title")}</DialogTitle></DialogHeader>
        <div className="mx-auto h-20 w-20 rounded-full bg-amber-50 grid place-items-center">
          <AlertTriangle size={48} className="text-amber-500 fill-amber-300" strokeWidth={2.2} data-testid="false-declaration-warning-icon" />
        </div>
        <DialogDescription className="text-sm text-slate-600 leading-relaxed text-center" data-testid="false-declaration-warning-text">
          {t(found ? "fd.textFound" : "fd.text")}
        </DialogDescription>
        <div className="mt-2 flex flex-col gap-2">
          <Button onClick={onContinue} className="rounded-full font-semibold bg-findo-navy hover:bg-findo-navy/90" data-testid="false-declaration-continue">
            {t("fd.continue")}
          </Button>
          <Button onClick={onCancel} variant="outline" className="rounded-full font-semibold" data-testid="false-declaration-cancel">
            {t("fd.cancel")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
